<template>
    <div
        class="outside-range"
        :class="containerClass"
        ref="wrapDiv"
        v-outsideclick="handleOutside"
    >
        <div class="place" :class="labelClass" @click="toggle(!show)">
            <div class="desc">
                <div>{{ label }}</div>
            </div>
            <div class="icon" :class="{ rotate: show }">
                <span class="iconfont icon-small-down"></span>
            </div>
        </div>
        <div class="dropdown_container" v-show="show" :class="dropStyle">
            <div class="container" :class="dropdownClass">
                <component
                    :is="component"
                    v-bind="$attrs"
                    @change="updateCondition"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Range from '../range/index.vue';
import Keyword from '../keyword/index.vue';
import SInput from '../s-input/index.vue';
import classNames from 'classnames';
import { inputBoxOutTag, keywordOutTag } from '@/common/search-tag-list';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    name: 'OutersideRange',
    emits: ['change'],
    data: function() {
        return {
            show: false,
            dropDownRef: null,
            dropStyle: "drop_left"
        };
    },
    computed: {
        ...mapState(usePageStore, {
            currencySymbol: store => store.currency.symbol,
            currencyRate: store => store.currencyRate
        }),
        component() {
            if (this.inputType === 'inputBox') {
                return Range;
            } else if (this.inputType === 'keyWord') {
                return Keyword;
            } else {
                return SInput;
            }
        },
        value() {
            return this.$attrs.value;
        },
        data: function() {
            return this.$attrs.data || {};
        },
        inputType() {
            return this.data.inputType || '';
        },
        label({ currencySymbol }) {
            switch (this.inputType) {
            case 'inputBox':
                return inputBoxOutTag(
                    this.value,
                    this.data.name,
                    this.data,
                    { currencySymbol, currencyRate: this.currencyRate }
                );
            case 'keyWord':
                return keywordOutTag(this.value, this.data.name, this.data);
            case 'text':
                if (this.value.trim()) {
                    return this.value;
                } else {
                    return this.data.label;
                }
            default:
                return this.data.label;
            }
        },
        theme() {
            return this.$attrs.theme || 'standard';
        },
        containerClass() {
            return classNames(this.theme);
        },
        labelClass({ theme, value, show }) {
            let temp = []
            if (value || show) {
                temp.push('active')
            }
            return classNames(theme, temp);
        },
        dropdownClass() {
            return classNames(this.theme);
        }
    },
    components: { Range },
    provide() {
        return {
            registerDropDown: this.registerDropDown
        };
    },
    created() {
    },
    methods: {
        registerDropDown(vm, isMount) {
            if (isMount) {
                if (!this.dropDownRef) {
                    this.dropDownRef = vm;
                }
            } else if (this.dropDownRef == vm) {
                this.dropDownRef = null;
            }
        },
        handleOutside() {
            this.toggle(false);
        },
        toggle(status) {
            if (status) {
                setTimeout(() => {
                    this.dropDownRef && this.dropDownRef.outsideOnShow();
                }, 30);
                if (this.$refs.wrapDiv) {
                    let rect = this.$refs.wrapDiv.getBoundingClientRect();
                    if (rect.left + 400 > window.innerWidth) {
                        this.dropStyle = "drop_right";
                    } else {
                        this.dropStyle = "drop_left";
                    }
                }
            }
            this.show = status;
        },
        updateCondition(value) {
            this.$emit('change', value);
        }
    }
};
</script>

<style lang="scss">
.outside-range {
    position: relative;
    .place {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .desc {
            flex: 1 0 0;
            overflow: hidden;
            div {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        &.standard {
            .desc {
                font-size: 16px;
                color: #515666;
                text-align: right;
            }
            .icon {
                .iconfont {
                    margin-right: 0;
                    color: #515666;
                }
            }
        }
        &.template4 {
            .desc {
                font-size: 16px;
                font-family: var(--font-medium);
                color: #8b93a7;
            }
            .icon {
                .iconfont {
                    margin-left: 6px;
                    font-weight: bold;
                    font-size: 18px !important;
                    color: #6b7282 !important;
                }
            }
        }
        .icon {
            transform-origin: 50% 50%;
            transition: transform 0.5s ease-in-out;
        }
        .icon.rotate {
            display: inline-block;
            transform: rotate(180deg);
        }
    }

    .dropdown_container {
        min-width: 400px;
        padding-top: 5px;
        position: absolute;
        top: 100%;
        width: 100%;
        z-index: var(--level-high);
        &.drop_left{
            left: 0;
        }
        &.drop_right{
            right: 0;
        }
        .container {
            border-radius: 2px;
            background-color: #fff;
            /* min-height: 300px; */
            &.layout1 {
                background: var(--g-bg-color);
                border: solid 1px var(--color-border);
            }
            &.standard {
                border: solid 1px var(--color-border);
            }
            &.template4 {
                border: solid 1px #d6dae8;
            }
            &.template1 {
                border: solid 1px #d5d5d5;
            }
        }
    }
}
</style>
